export default Object.freeze({
  COMPANY: 'company',
  COMPANY_SUB_ROLES: Object.freeze({
    CORPORATE: 'corporate',
    USER: 'user'
  }),
  FREELANCE: 'freelance'
});
